import { html, TemplateResult } from 'lit';
import { WEB_COMPONENT_EASM_RECENT_ASSETS } from '../../../../webcomponents.constants';
import { customElement, property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { translateFn } from '../../../../utils/translator.helper';
import { generateFiltersForInventory, handleWidgetWithTopDataResize } from '../../../utils/utils';
import { GzEasmGenericTopDataWebComponent } from '../../genericTopData';
import { EasmMostRecentAssetsPayload } from '@nirvana/shared/dtos/types/widgets/common';
import { FilterType, RowData } from '../../genericTopData/types/types';
import moment from 'moment-timezone';
import { getTimezone } from '../../../../utils/global.utils';
import { MIN_NUMBER_OF_ROWS_TO_DISPLAY } from '../../constants';
import { FindingClassType } from '../../../types';
import { store } from '../../../../redux/store';
import { selectDashboardFilterValues } from '../../../../genericDashboard/redux/dashboard.filters.slice';
import { GenericDashboardsFiltersHelper } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { NextScanInclusionStatus } from '../../../assetsInventoryGrid/types';

@customElement(WEB_COMPONENT_EASM_RECENT_ASSETS)
export class GzEasmMostRecentAssetsWebComponent extends GzGenericWidgetContent {
  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: EasmMostRecentAssetsPayload;

  // This is used for widget resize handle
  @query('gz-easm-generic-top-data')
  private gzEASMGenericTopData: GzEasmGenericTopDataWebComponent;

  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  protected renderContent(): TemplateResult {
    const rowData: RowData[] = [];
    const data = this.payload?.easmMostRecentAssets;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        rowData.push({
          label: data[key].name,
          date: moment(data[key].dateAdded).tz(getTimezone()).format('DD MMMM YYYY, HH:mm'),
          value: data[key].userName,
        });
      }
    }
    const numberOfObjects = Object.keys(rowData).length;
    return html`
      <gz-easm-generic-top-data
        .rowsData=${rowData}
        .buttonText=${translateFn('Add more assets to next scan')}
        .showDate=${true}
        .numberOfRowsAvailable=${numberOfObjects}
        .minNumberOfRowsToDisplay=${MIN_NUMBER_OF_ROWS_TO_DISPLAY}
        .numberOfRowsToDisplay=${numberOfObjects}
        .navigateToSmartViewId=${this.payload?.inventorySmartViewId}
        .filterType="${FilterType.FINDING_NAME}"
        .clickableRow="${true}"
        .findingType="${FindingClassType.ASSET}"
      >
      </gz-easm-generic-top-data>
    `;
  }

  protected handleResize(): void {
    super.handleResize();
    handleWidgetWithTopDataResize.call(this);
  }

  public async handleTitleClick() {
    const dashboardAppState = store.getState().dashboardsApp;
    const filters = selectDashboardFilterValues(dashboardAppState);
    const companyId = GenericDashboardsFiltersHelper.getCompanyIdFromSingleSelectCompanyFilter(filters) as string;

    const filtersToSend = generateFiltersForInventory(FilterType.ASSET_STATUS, '', companyId, [
      NextScanInclusionStatus.INCLUDED,
    ]);
    await NavigationHelper.navigateToEASMAssetsInventory({
      smartViewId: this.payload?.inventorySmartViewId as string,
      filters: filtersToSend,
    });
  }
}
